import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const SUPPORTED = ['en', 'fr', 'de', 'da'];

export function usePageLang() {
  const { i18n } = useTranslation();
  const location = useLocation();

  const [currentLang, setCurrentLang] = useState(() => {
    const pathLang = location.pathname.split('/')[1];
    if (SUPPORTED.includes(pathLang)) return pathLang;
    const stored = localStorage.getItem('preferred-language');
    if (stored && SUPPORTED.includes(stored)) return stored;
    const browserLang = navigator.language.split('-')[0];
    if (SUPPORTED.includes(browserLang)) return browserLang;
    return 'en';
  });

  // Sync language with URL path
  useEffect(() => {
    const pathLang = location.pathname.split('/')[1];
    if (SUPPORTED.includes(pathLang) && pathLang !== currentLang) {
      setCurrentLang(pathLang);
    }
  }, [location.pathname]);

  useEffect(() => {
    i18n.changeLanguage(currentLang);
    localStorage.setItem('preferred-language', currentLang);
    document.documentElement.lang = currentLang;
  }, [currentLang, i18n]);

  const handleLanguageChange = (lang: string) => {
    setCurrentLang(lang);
    const newPath = location.pathname.replace(/^\/[a-z]{2}(?=\/|$)/, `/${lang}`);
    if (newPath !== location.pathname) {
      window.location.href = newPath;
    }
  };

  return { currentLang, handleLanguageChange };
}